import React from 'react';
import { getMentionProvider } from '../registry';

export interface MentionChipProps {
  id: string;
  label: string;
  kind: string;
}

export function MentionChip({ id, label, kind }: MentionChipProps) {
  const provider = getMentionProvider(kind);
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    provider?.onChipClick?.(id);
  };
  return (
    <button
      type="button"
      className={`mention-chip mention-chip--${kind}`}
      onClick={handleClick}
      aria-label={`Open ${label}`}
    >
      @{label}
    </button>
  );
}
